import { Container, Typography, Card } from "@mui/material";
import React from "react";

export default function Welcome() {
  return (
    <Container>
      <Card sx={{padding:"20px",}}>
        <Typography variant="body" sx={{fontSize:"16pt"}}>
          Welcome to the Law Captain's website. Ed Russell served as an U.S. Air
          Force Captain and when he was honorably discharged from service, then
          went to law school to continue serving his community. As with any
          legal issue, the first thing to be aware of is the statute of
          limitations for your case. Most clients will not have enough time to
          make a successful claim if given less than four months. In my
          experience, even in open and shut cases, the average time to file a
          claim and receive what you are owed is four to six months. If you have
          less time than that, contact an attorney immediately to preserve your
          right to financial recovery.
        </Typography>
      </Card>
    </Container>
  );
}
